import { RenderingEngine } from '@cornerstonejs/core';
import { renderingEngineId } from '../contexts/ImageViewerCornerstoneContext';

const createDefaultRenderingEngine = customId => new RenderingEngine(customId || renderingEngineId);

export default createDefaultRenderingEngine;
